import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";
import GrantButton from "./components/buttons/GrantButton";
import OperatorTable from "./components/tables/OperatorTable";

export default function OperatorPage() {
  return (
    <Box>
      <Stack direction="row" sx={{ width: "100%", marginBottom: 2 }}>
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Operators
        </Typography>
        <GrantButton />
      </Stack>

      <OperatorTable />
    </Box>
  );
}
